// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Tu8gw","label":"styles_label__0m0f4","input":"styles_input__dhEnI","radio":"styles_radio__HQq1X"};